import { lazy } from "react";
import { setStudioView } from "../workspace/studio-views";
import type { DirectorReviewProps } from "./DirectorReview";
const DirectorReview = lazy(() => import("./DirectorReview").then(module => ({ default: module.DirectorReview })));
export function mountDirectorReview(
  slot: HTMLElement,
  props: DirectorReviewProps,
) {
  setStudioView("director-review", `director-review:${props.project.id}`, <DirectorReview {...props} />);
}
